const organization = {
    require_membership: '사용자는 조직의 구성원이어야 합니다.',
    role_names_not_found: '유효하지 않은 역할 이름이 감지되었습니다: {{names,list(type:conjunction)}}. 계속하기 전에 먼저 이 역할들을 생성해 주세요.',
};
export default Object.freeze(organization);
